(() => {
  if (customElements.get('reels-slider')) {
    return;
  }

  class ReelsSlider extends customElements.get('slider-component') {
    get currentlyPlayingReel() {
      return this.querySelector('video.is-playing');
    }

    constructor() {
      super();
      this.options = {
        ...this.options,
        ...{
          touchEventsTarget: 'container',
          spaceBetween: 16,
          slidesPerView: 1,
          loop: true,
          centeredSlides: true,
          breakpoints: {
            750: {
              slidesPerView: 2
            },
            990: {
              speed: 1000,
              slidesPerView: Math.min(
                3,
                Number(this.dataset.itemsPerSlide)
              )
            },
            1280: {
              speed: 1000,
              slidesPerView: Math.min(
                4,
                Number(this.dataset.itemsPerSlide)
              )
            },
            1440: {
              speed: 1000,
              slidesPerView: Number(this.dataset.itemsPerSlide)
            }
          },
          on: {
            init: () => {
              this.onSlideChange();
            },
            slideChangeTransitionEnd: swiper => {
              this.onSlideChange(swiper);
            }
          }
        }
      };
    }

    /**
     * Init slider.
     *
     * @extends {SliderComponent}
     */
    initSlider() {
      super.initSlider();
      this.handleResize = debounce(() => {
        this.updateArrowsPosition();
      }, 100);
      window.addEventListener('resize', this.handleResize);
      this.updateArrowsPosition();
    }

    /**
     * Disconnected callback.
     *
     * @extends {SliderComponent}
     */
    disconnectedCallback() {
      super.disconnectedCallback();
      if (this.handleResize) {
        window.removeEventListener('resize', this.handleResize);
      }
    }

    /**
     * Update arrows position.
     *
     * @returns {Void}
     */
    updateArrowsPosition() {
      const slideMedia = this.querySelector('[data-slide-media]');
      if (slideMedia === null) {
        return;
      }
      const slideMediaHeight = slideMedia.offsetHeight;
      const arrows = this.querySelector('.slider__arrows');
      if (!arrows) {
        return;
      }
      arrows.setAttribute('style', `top: ${slideMediaHeight / 2}px`);
    }

    /**
     * On slide change.
     *
     * @param {Object<SwiperObject>} swiper
     * @returns {Void}
     */
    onSlideChange(swiper) {
      const activeReel = this.currentlyPlayingReel;
      if (activeReel) {
        this.toggleVideoState(activeReel);
      }

      const activeSlideReel = this.querySelector(
        '.swiper-slide-active video'
      );
      if (!activeSlideReel) {
        return;
      }

      this.toggleVideoState(activeSlideReel);
    }

    /**
     * Toggle video state.
     *
     * @param {HTMLVideoElement} video
     * @returns {Void}
     */
    toggleVideoState(video) {
      video.classList.toggle('is-playing', video.paused);
      if (video.paused) {
        video.play();
        return;
      }

      video.pause();
    }

    /**
     * @overwrite
     */
    setPaginationState() {
      return;
    }
  }

  customElements.define('reels-slider', ReelsSlider);
})();
